import { ConfigSystemParams, TypeLicence } from "../consts";
import { ConfigSystemService } from "../services/utelize/system/config-system/config-system-service";
import { ExceptionsService } from "../services/utelize/general/exceptions-service";

export function licenceBillFromFirstOfNextMonth(configSystemService: ConfigSystemService,
                                                exceptionsService  : ExceptionsService,
                                                licenceType        : string,
                                               ): boolean {
  try {
    return (licenceType==TypeLicence.Bundle     && configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesBillStartOfNextMonthBundle,     false)) ||
           (licenceType==TypeLicence.Feature    && configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesBillStartOfNextMonthFeature,    false)) ||
           (licenceType==TypeLicence.Platform   && configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesBillStartOfNextMonthPlatform,   false)) ||
           (licenceType==TypeLicence.PoolBundle && configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesBillStartOfNextMonthPoolBundle, false)) ||
           (licenceType==TypeLicence.Usage      && configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesBillStartOfNextMonthUsage,      false));
  }
  catch(e) {
    exceptionsService.handleException(<Error>e);
    return false;
  }
}
